export default (function (methodType) {
  return function (items) {
    return {
      methodType: methodType,
      body: {
        items: items || null
      }
    };
  };
});